import { createEffect, ofType } from "@ngrx/effects";
import { EffectMetadata } from "@ngrx/effects/src/models";
import { Action, ActionCreator } from "@ngrx/store";
import { iif, SubscribableOrPromise } from "rxjs";
import { mergeMap } from "rxjs/operators";
import { NgrxActions } from "../decorators.module";
import { addEffectMetadataEntry, DEFAULT_EFFECT_CONFIG, EffectPropertyKey } from "../utils/helpers";
import { ofEnforcedType } from "../utils/of-enforced-type";

export interface IDispatchOnDoneConfig {
  actions: ActionCreator[],
  dispatch: ActionCreator
}

export function DispatchOnActionEffect(config: IDispatchOnDoneConfig) {
  return function <T extends Object, K extends EffectPropertyKey<T>>(
    target: T,
    propertyKey: K
  ) {

    if (delete target[propertyKey]) {


      const metadata: EffectMetadata<T> = {
        ...DEFAULT_EFFECT_CONFIG,
        propertyName: propertyKey,
      };

      let efunc: any;
      Object.defineProperty(target, propertyKey, {
        get: () => {

          const { actions$ } = NgrxActions;

          if (actions$ === null) {
            throw new Error(`${NgrxActions.name} not connected to store!, Please ensure you are injecting NgrxHelperModule`);
          }

          const actionCb = () => actions$.pipe(
            ofType(...[...config.actions]),
            mergeMap((p) => {
              return iif(() => !!p,
                ofEnforcedType<SubscribableOrPromise<never>>([config.dispatch(p) as Action]),
                ofEnforcedType<SubscribableOrPromise<never>>([config.dispatch() as Action])
              )
            })
          );

          const effect = () => {
            return createEffect(actionCb as any);
          };

          if (!efunc) {
            efunc = effect();
          }
          return efunc;

        },
        set: () => { },
      });

      addEffectMetadataEntry<T>(target, metadata);

    }

  }

}
